import { Entity } from '@data-client/rest';
class EmailReportEntity extends Entity {
    constructor() {
        super(...arguments);
        this.email = '';
    }
    pk() {
        return this.email;
    }
}
EmailReportEntity.key = 'EmailReport';
export { EmailReportEntity };
